import { create } from 'zustand';

interface OnboardState {
  currentStep: number;
  completedSteps: number[];
  skippedSteps: number[];
  totalSteps: number;

  nextStep: () => void;
  previousStep: () => void;
  goToStep: (step: number) => void;
  completeStep: (step: number) => void;
  skipStep: (step: number) => void;
  reset: () => void;
}

export const useOnboardStore = create<OnboardState>((set) => ({
  currentStep: 0,
  completedSteps: [],
  skippedSteps: [],
  totalSteps: 11,

  nextStep: () => {
    set((state) => ({
      currentStep: Math.min(state.currentStep + 1, state.totalSteps - 1),
    }));
  },

  previousStep: () => {
    set((state) => ({
      currentStep: Math.max(state.currentStep - 1, 0),
    }));
  },

  goToStep: (step) => {
    set((state) => ({
      currentStep: Math.max(0, Math.min(step, state.totalSteps - 1)),
    }));
  },

  completeStep: (step) => {
    set((state) => ({
      completedSteps: state.completedSteps.includes(step)
        ? state.completedSteps
        : [...state.completedSteps, step],
    }));
  },

  skipStep: (step) => {
    set((state) => ({
      skippedSteps: state.skippedSteps.includes(step)
        ? state.skippedSteps
        : [...state.skippedSteps, step],
    }));
  },

  reset: () => {
    set({
      currentStep: 0,
      completedSteps: [],
      skippedSteps: [],
    });
  },
}));
